import { useEffect } from 'react';

interface FullExamTimerProps {
  secondsLeft: number;
  onTick: () => void;
  onTimeUp: () => void;
}

export default function FullExamTimer({ secondsLeft, onTick, onTimeUp }: FullExamTimerProps) {
  useEffect(() => {
    if (secondsLeft <= 0) {
      onTimeUp();
      return;
    }

    const timer = setInterval(() => {
      onTick();
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft, onTick, onTimeUp]);

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  const getTimerColor = () => {
    if (secondsLeft <= 600) return 'text-red-600';
    if (secondsLeft <= 1800) return 'text-amber-600';
    return 'text-slate-700';
  };

  const getTimerBg = () => {
    if (secondsLeft <= 600) return 'bg-red-50 border-red-200';
    if (secondsLeft <= 1800) return 'bg-amber-50 border-amber-200';
    return 'bg-white border-slate-200';
  };

  return (
    <div className={`flex items-center gap-2 px-4 py-2 rounded-lg border-2 ${getTimerBg()} transition-colors`}>
      <i className={`ri-time-line text-lg ${getTimerColor()}`}></i>
      <div className={`font-semibold text-base ${getTimerColor()}`}>
        {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
      </div>
    </div>
  );
}